import React from "react";
import SocialIcon from "./SocialIcon";
import { SOCIALS } from "../data/content";

const links = [
  { label: "Accueil", id: "accueil" },
  { label: "Musique", id: "musique" },
  { label: "Concerts", id: "concerts" },
  { label: "Boutique", id: "boutique" },
  { label: "Contact", id: "contact" },
];

export const Footer = () => {
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer data-testid="footer" className="relative overflow-hidden border-t border-white/10 bg-[#050505] py-14 pb-28">
      <div className="orb orb-purple" style={{ width: 300, height: 300, bottom: "-40%", left: "50%", transform: "translateX(-50%)" }} />
      <div className="relative z-10 mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col items-center gap-8 text-center">
          <button onClick={() => go("accueil")} className="wordmark neon-text font-display text-4xl font-black">
            OLI.VERO
          </button>

          <nav className="flex flex-wrap justify-center gap-6">
            {links.map((l) => (
              <button
                key={l.id}
                data-testid={`footer-nav-${l.id}`}
                onClick={() => go(l.id)}
                className="font-heading text-sm text-white/60 transition-colors hover:text-white"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <div className="flex flex-wrap justify-center gap-3">
            {SOCIALS.map((s) => (
              <SocialIcon key={s.key} name={s.name} url={s.url} k={s.key} />
            ))}
          </div>

          <p className="font-body text-xs text-white/40">
            © {new Date().getFullYear()} OLI.VERO — DJ & Producteur franco-italien. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
